import { Menu, Table } from 'antd';
import styled from 'styled-components';
export const SpacerMenu = styled(Menu.Item)`
  padding-top: 15px;
  padding-bottom: 15px;

  &:hover {
    background: #ffba00;
    color: #fff;
  }
`;
export const Image = styled.img`
  width: 39px;
  height: 58px;
`;
export const GreyText = styled.span`
  color: #c4c4c4;
  font-size: 14px;
  max-width: 200px;
  word-wrap: break-word;
  display: block;
`;
export const BlackText = styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  max-width: 200px;
  word-wrap: break-word;
  display: block;
`;
export const DownloadButton = styled.a`
  color: #c4c4c4;
  font-size: 12px;
  text-align: center;
  display: block;
`;
export const Title = styled.h4`
  color: #778ca2;
  font-size: 24px;
  margin: 20px 0;
  font-weight: 400;
`;
export const FileType = styled.span`
  color: #4d7cfe;
`;
export const StyledTable = styled(Table)`
  table {
    border: 1px solid #c4c4c4;
    thead {
      th {
        background: #f9fafc;
      }
    }
  }
`;
export const SecActions = styled.section`
  margin-bottom: 15px;
`;